import type { MouseEvent } from 'react'

/**
 * **Ein Klick auf den Hintergrund schließt den Dialog – aber nur ein echter** (09.09.2026,
 * [E-337](../../../../docs/ENTSCHEIDUNGEN.md#e-337)).
 *
 * Christian Hunhoff: *„Bei mir ist das Fenster schon so oft geschlossen worden, weil die Maus
 * kurz außerhalb des Fensters war. … Bin mittlerweile darüber übergegangen, Texte in Notepad
 * vorzuschreiben."*
 *
 * Das war kein Gefühl, sondern der Browser: ein `click` landet auf dem **gemeinsamen
 * Vorfahren** von Drücken und Loslassen. Wer im Dialog Text markiert und die Maus erst neben
 * dem Fenster loslässt, erzeugt damit einen Klick auf den Hintergrund – und der Dialog ging zu,
 * mitsamt allem, was darin stand. Deshalb zählt ein Hintergrundklick nur, wenn **beides**,
 * Drücken und Loslassen, auf dem Hintergrund lag.
 *
 * `erlaubt = false` schaltet das Schließen per Hintergrund ganz ab (Anlegen-Dialog mit Text).
 * Escape und der Abbrechen-Knopf bleiben davon unberührt – die sind eine Entscheidung.
 */
export function hintergrundSchliesst(schliessen: () => void, erlaubt = true) {
  let gedruecktAufHintergrund = false
  return {
    onMouseDown: (e: MouseEvent<HTMLElement>) => {
      gedruecktAufHintergrund = e.target === e.currentTarget
    },
    onClick: (e: MouseEvent<HTMLElement>) => {
      if (e.target !== e.currentTarget) return
      if (!gedruecktAufHintergrund) return
      gedruecktAufHintergrund = false
      if (erlaubt) schliessen()
    },
  }
}
